import PremiumLanding from "@/components/PremiumLanding";
export default function Enterprise() {
  return <PremiumLanding
    testid="enterprise-page"
    badge="YUMO Enterprise"
    title="Food intelligence for chefs and caterers."
    tagline="Given this event and these guests — what menu should you serve?"
    description="Enterprise applies YUMO's Intelligence Engine to hospitality: hotels, restaurants, caterers, cloud kitchens, and event planners. Not an ERP. An intelligent menu partner."
    capabilities={[
      { label: "Event Intelligence", detail: "Type, guest count, age groups, regional preferences, weather, and season — all understood in one prompt." },
      { label: "Menu Storybook", detail: "Course-sequenced menus with taste balance and cultural coherence." },
      { label: "Taste Spread", detail: "Handle dietary diversity across a large audience without manual planning." },
      { label: "Chef Companion", detail: "Ingredient planning at scale. Menu narratives to share with your team and guests." },
    ]}
  />;
}
